export default __webpack_public_path__ + "static/Kalyan-Rao-710604ff6a61c0b49bac36bb9ae0f094.jpg";